// Auto-generated TypeScript enum from PHP enum

export type SystemPermission = 'access_ai_agent' | 'access_mcp' | 'debug_ai_conversations' | 'export_workspace' | 'impersonate_identities' | 'import_workspace' | 'manage_ai_skills' | 'manage_branches' | 'manage_brand_kit' | 'manage_calendar_connections' | 'manage_components' | 'manage_data_imports' | 'manage_diagonal_wallet' | 'manage_domains' | 'manage_fields' | 'manage_media' | 'manage_notifications' | 'manage_packages' | 'manage_pages' | 'manage_resources' | 'manage_security' | 'manage_shared_filters' | 'manage_sub_workspaces' | 'manage_tests' | 'manage_workflows' | 'manage_workspace_fields' | 'manage_workspace_settings' | 'reopen_wallet_accounting_periods' | 'send_emails' | 'send_sms' | 'show_diagonal_support_chat' | 'access_system_admin' | 'update_workspace_fields' | 'view_ai_costs' | 'view_entity_graph' | 'view_workspace_analytics';

export const SystemPermission = {
  AccessAiAgent: 'access_ai_agent' as const,
  AccessMcp: 'access_mcp' as const,
  DebugAiConversations: 'debug_ai_conversations' as const,
  ExportWorkspace: 'export_workspace' as const,
  ImpersonateIdentities: 'impersonate_identities' as const,
  ImportWorkspace: 'import_workspace' as const,
  ManageAiSkills: 'manage_ai_skills' as const,
  ManageBranches: 'manage_branches' as const,
  ManageBrandKit: 'manage_brand_kit' as const,
  ManageCalendarConnections: 'manage_calendar_connections' as const,
  ManageComponents: 'manage_components' as const,
  ManageDataImports: 'manage_data_imports' as const,
  ManageDiagonalWallet: 'manage_diagonal_wallet' as const,
  ManageDomains: 'manage_domains' as const,
  ManageFields: 'manage_fields' as const,
  ManageMedia: 'manage_media' as const,
  ManageNotifications: 'manage_notifications' as const,
  ManagePackages: 'manage_packages' as const,
  ManagePages: 'manage_pages' as const,
  ManageResources: 'manage_resources' as const,
  ManageSecurity: 'manage_security' as const,
  ManageSharedFilters: 'manage_shared_filters' as const,
  ManageSubWorkspaces: 'manage_sub_workspaces' as const,
  ManageTests: 'manage_tests' as const,
  ManageWorkflows: 'manage_workflows' as const,
  ManageWorkspaceFields: 'manage_workspace_fields' as const,
  ManageWorkspaceSettings: 'manage_workspace_settings' as const,
  ReopenWalletAccountingPeriods: 'reopen_wallet_accounting_periods' as const,
  SendEmails: 'send_emails' as const,
  SendSms: 'send_sms' as const,
  ShowDiagonalSupportChat: 'show_diagonal_support_chat' as const,
  SystemAdministrator: 'access_system_admin' as const,
  UpdateWorkspaceFields: 'update_workspace_fields' as const,
  ViewAiCosts: 'view_ai_costs' as const,
  ViewEntityGraph: 'view_entity_graph' as const,
  ViewWorkspaceAnalytics: 'view_workspace_analytics' as const,
} as const;

export const SystemPermissionUtils = {
  values: Object.values(SystemPermission),
  keys: Object.keys(SystemPermission) as Array<keyof typeof SystemPermission>,
  entries: Object.entries(SystemPermission) as Array<[keyof typeof SystemPermission, SystemPermission]>,
  isValid: (value: any): value is SystemPermission => Object.values(SystemPermission).includes(value),
  fromKey: (key: keyof typeof SystemPermission): SystemPermission => SystemPermission[key],
};

